import axios from "axios";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { PO_API } from "../CreatePurchaseOrder/data";
import { ginesysSyncTone } from "../CreatePurchaseOrder/poUi";

export const lsPoSyncLogFilterValStr = "purchase_order_sync_log_filter_obj";

export const poSyncLogEventTone = {
	QUEUED: { color: "#1565c0", bgcolor: "#e3f2fd" },
	SUCCESS: { color: "#2e7d32", bgcolor: "#e8f5e9" },
	FAILED: { color: "#b71c1c", bgcolor: "#ffebee" },
	SKIPPED: { color: "#5f6368", bgcolor: "#eef0f2" },
	REOPENED: { color: "#b76e00", bgcolor: "#fff4e5" },
};

export const retryPurchaseOrderSyncApi = (poId, { outbox_id } = {}) =>
	axios.post(`${PO_API}/${poId}/retry-sync`, outbox_id != null ? { outbox_id } : {});

export const syncPurchaseOrderCostApi = (poId) => axios.post(`${PO_API}/${poId}/sync-cost`);

export const reopenPurchaseOrderForEditApi = (poId, { outbox_id } = {}) =>
	axios.post(`${PO_API}/${poId}/reopen-for-edit`, outbox_id != null ? { outbox_id } : {});

export const poSyncLogEventOptions = Object.keys(poSyncLogEventTone).map((key) => ({ key, name: key }));
export const ginesysSyncOptions = Object.keys(ginesysSyncTone).map((key) => ({ key, name: key }));

const enterColumn = (name, key, dataType = datatypes.STRING.key) => ({
	name,
	key,
	input_type: inputTypes.ENTER.key,
	data_type: dataType,
	editable: true,
	constraints: { DISPLAY: true },
});

const selectColumn = (name, key, list) => ({
	name,
	key,
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	editable: true,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list,
	},
});

export const poSyncLogColumnsObj = {
	id: enterColumn("ID", "id", datatypes.NUMBER.key),
	purchase_order_id: enterColumn("PO ID", "purchase_order_id", datatypes.NUMBER.key),
	po_no: enterColumn("PO No", "po_no"),
	event_type: selectColumn("Event", "event_type", poSyncLogEventOptions),
	ginesys_sync: selectColumn("Ginesys Sync", "ginesys_sync", ginesysSyncOptions),
	ginesys_po_id: enterColumn("Ginesys PO Id", "ginesys_po_id", datatypes.NUMBER.key),
	ginesys_scheme_doc_no: enterColumn("Ginesys Scheme Doc No", "ginesys_scheme_doc_no"),
	outbox_id: enterColumn("Outbox ID", "outbox_id", datatypes.NUMBER.key),
	triggered_by: enterColumn("Triggered By", "triggered_by"),
	error_message: enterColumn("Error", "error_message"),
	created_at: enterColumn("Created At", "created_at", datatypes.DATE.key),
};

export const poSyncLogTableColumns = [
	poSyncLogColumnsObj.id,
	poSyncLogColumnsObj.created_at,
	poSyncLogColumnsObj.po_no,
	poSyncLogColumnsObj.purchase_order_id,
	poSyncLogColumnsObj.event_type,
	poSyncLogColumnsObj.ginesys_sync,
	poSyncLogColumnsObj.ginesys_po_id,
	poSyncLogColumnsObj.ginesys_scheme_doc_no,
	poSyncLogColumnsObj.triggered_by,
	poSyncLogColumnsObj.error_message,
].map((col) => ({
	...col,
	align: "center",
	headerAlign: "center",
	minWidth:
		col.key === "po_no" ||
		col.key === "ginesys_scheme_doc_no" ||
		col.key === "error_message" ||
		col.key === "triggered_by"
			? 160
			: col.key === "created_at"
				? 150
				: 110,
}));

export const getPoSyncLogFilterColumns = () => [
	poSyncLogColumnsObj.po_no,
	poSyncLogColumnsObj.purchase_order_id,
	poSyncLogColumnsObj.event_type,
	poSyncLogColumnsObj.ginesys_sync,
	poSyncLogColumnsObj.ginesys_po_id,
	poSyncLogColumnsObj.triggered_by,
	poSyncLogColumnsObj.outbox_id,
];

export const listPurchaseOrderSyncLogsApi = async ({ limit, offset, filter }) => {
	const res = await axios.post(`${PO_API}/sync-logs`, { limit, offset, filter });
	return res.data?.result || { rows: [], total_rows_count: 0 };
};
